import { useMemo } from 'react';
import useSWR from 'swr';
import { countriesList } from 'services/countriesList';

/**
 * Hook personalizado para obtener y procesar los datos de países.
 * Centraliza la lógica de obtención de países y los maps derivados.
 * @returns Objeto con los datos de países y los maps de conversión
 */
const useCountriesData = () => {
  const { data: countriesData } = useSWR('countries-list', () => countriesList(), {
    revalidateOnFocus: false
  });

  const countryIdToNameMap = useMemo(() => {
    if (!countriesData) return new Map<number, string>();
    return new Map(countriesData.map(country => [country.id || 0, country.name || '']));
  }, [countriesData]);

  const countryNameToIdMap = useMemo(() => {
    if (!countriesData) return new Map<string, number>();
    return new Map(countriesData.map(country => [country.name || '', country.id || 0]));
  }, [countriesData]);

  const countriesOptions = useMemo(() => {
    if (!countriesData) return [];
    return countriesData.map(country => country.name || '').filter(Boolean);
  }, [countriesData]);

  return {
    countriesData,
    countryIdToNameMap,
    countryNameToIdMap,
    countriesOptions
  };
};

export default useCountriesData;
